import styled from 'styled-components';

export const Container = styled.dialog`
    background: #ffffff;
    border-radius: 8px;
    border: 0;
    padding: 0;
    outline: none;
`;
